module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAi0lEQVQoU62RPQpCQRCDvzTiD4rCw+4dxsLTeDQLW68kqKj4KovIyj6ZXQsLDUwzCSGTERVsC9gCB0mbSCeigO0ZcE0jaf5NPAVuwElS85s45+xNxsAdOALLwtn2DlhX0SeAgQ543yXbe2BViQdZ/PjIbHsYliPgnGO0Yf/qtK7uj21E6/CUi6RF5J5tFzn1lXXMMgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/add.png
// module id = sXzr
// module chunks = 2